<script lang="ts">
  import { SvelteToast, toast } from "@zerodevx/svelte-toast";
  import { setContext } from "svelte";
  import { apiClient } from "./apiClient";
  import { isAuthenticated } from "./stores";

  import Attendant from "./Attendant.svelte";
  import Orders from "./Orders.svelte";
  import Login from "./Login.svelte";

  setContext("apiClient", apiClient);

  const toastOptions = { intro: { y: 256 } };

  function handleLogout() {
    apiClient.logout();
    toast.push("Erfolgreich abgemeldet!", {
      theme: {
        "--toastColor": "white",
        "--toastBackground": "rgba(40, 167, 69, 0.9)",
        "--toastBarBackground": "#28a745",
      },
    });
  }
</script>

{#if !$isAuthenticated}
  <div class="toast-wrapper">
    <SvelteToast options={toastOptions} />
  </div>
  <Login />
{:else}
  <main>
    <SvelteToast options={toastOptions} />
    <div id="blocker" />
    <div class="header">
      <h1>Bestellungen</h1>
      <button class="logout-button" on:click={handleLogout}> Abmelden </button>
    </div>
    <Attendant />
    <Orders />
  </main>
{/if}

<style>
  main {
    font-family: "Content", serif;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    display: flex;
    height: 100%;
    min-height: 100%;
    flex-direction: column;
    flex: 1;
    margin: 0;
  }

  .toast-wrapper {
    font-family: "Content", serif;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 2rem;
    background: linear-gradient(135deg, #ff7e5f, #feb47b);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .header h1 {
    margin: 0;
    flex: 1;
  }

  h1 {
    font-family: Title, cursive;
    font-size: 4rem;
    margin-bottom: 0;
    text-align: center;
    color: white;
  }

  .logout-button {
    background: rgba(231, 76, 60, 0.9);
    color: white;
    border: none;
    border-radius: 8px;
    padding: 0.5rem 1rem;
    font-family: "Content", serif;
    font-weight: bold;
    cursor: pointer;
    transition:
      transform 0.2s,
      box-shadow 0.2s,
      background-color 0.3s;
    margin-left: 1rem;
    backdrop-filter: blur(5px);
  }

  .logout-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(231, 76, 60, 0.4);
    background: rgba(192, 57, 43, 0.95);
  }

  @media (max-width: 768px) {
    .header {
      flex-direction: column;
      text-align: center;
      padding: 1rem;
    }

    .header h1 {
      margin-bottom: 0.5rem;
      font-size: 3rem;
    }

    .logout-button {
      margin-left: 0;
    }
  }

  #blocker {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.733);
    z-index: 999999;
    display: none;
  }

  #blocker::before {
    text-align: center;
    color: white;
    font-size: 2em;
    content: "Netzwerkfehler 😞";
    position: absolute;
    white-space: pre;
    display: inline;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -25px);
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }

  @font-face {
    font-family: "Title";
    src: url("/fonts/ReenieBeanie-Regular.ttf");
  }

  @font-face {
    font-family: "Header";
    src: url("/fonts/AmaticSC-Bold.ttf");
  }

  @font-face {
    font-family: "Content";
    src: url("/fonts/Kalam-Regular.ttf");
  }

  :root {
    --toastContainerTop: auto;
    --toastContainerRight: auto;
    --toastContainerBottom: 1rem;
    --toastContainerLeft: calc(50vw - 8rem);
  }
</style>
